<template>
	<teleport to="body">
		<div class="app-dialog">
			<div class="app-dialog__backdrop" @click="$emit('close')"></div>

			<transition name="fade" appear>
				<div class="app-dialog__panel">
					<header class="app-dialog__header">
						<template v-if="$slots.header">
							<slot name="header"/>
						</template>
						<template v-else>
							<h5 class="app-dialog__title m-0">{{ title }}</h5>
						</template>
						<button v-if="close" class="app-dialog__close" @click="$emit('close')">
							<XmarkIcon/>
						</button>
					</header>

					<div class="app-dialog__body">
						<slot/>
					</div>

					<footer v-if="$slots.footer || $slots['footer-top']" :class="['app-dialog__footer', { 'app-dialog__footer--column': $slots['footer-top'] }]">
						<template v-if="$slots['footer-top']">
							<div class="footer-top-slot">
								<slot name="footer-top"/>
							</div>
						</template>

						<slot name="footer"/>
					</footer>
				</div>
			</transition>
		</div>
	</teleport>
</template>

<script>
import XmarkIcon from "@/core/icons/XmarkIcon.vue";

export default {
	name: "AppModalCentered",
	emits: ["close"],
	components: {XmarkIcon},
	props: {
		title: {
			type: String,
			default: "Diálogo",
		},
		close: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped>
.app-dialog {
	position: fixed;
	inset: 0;
	z-index: 103;
	display: flex;
	align-items: center;
	justify-content: center;
}

.app-dialog__backdrop {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.5);
}

.app-dialog__panel {
	background: var(--app-primary, #fff);
	color: var(--app-primary-color, #000);
	box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
	display: flex;
	flex-direction: column;
	z-index: 102;
	overflow: hidden;
}

/* Encabezado */
.app-dialog__header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1rem;
	border-bottom: 1px solid var(--app-accent);
}

.app-dialog__title {
	margin: 0;
	font-size: 1.25rem;
	font-weight: bold;
}

.app-dialog__close {
	background: none;
	border: none;
	font-size: 1.5rem;
	cursor: pointer;
	color: inherit;
}

/* Cuerpo */
.app-dialog__body {
	padding: 1rem;
	overflow-y: auto;
	flex: 1;
}

/* Pie */
.app-dialog__footer {
	padding: 1rem;
	border-top: 1px solid var(--app-accent);
	display: flex;
	justify-content: flex-end;
	gap: 0.5rem;
	background: transparent;
}

.app-dialog__footer--column {
	flex-direction: column;
	align-items: stretch;
	justify-content: unset;
}

/* Fade animation */
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
	opacity: 1;
}

/* Móvil: modal centrado como en desktop */
@media (max-width: 767.98px) {
	.app-dialog__panel {
		width: 90%;
		max-width: 500px;
		max-height: 90vh;
		border-radius: 16px;
	}
}

/* Desde md en adelante: igual */
@media (min-width: 768px) {
	.app-dialog__panel {
		width: 90%;
		max-width: 500px;
		max-height: 90vh;
		border-radius: 16px;
	}
}
</style>
